
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'accessible': {
    width: 16,
    height: 16,
    viewBox: '0 0 14 20',
    data: '<path pid="0" d="M14 11V9a5.615 5.615 0 0 1-4.07-1.83L8.64 5.74a1.934 1.934 0 0 0-.61-.45c-.01 0-.01-.01-.02-.01H8a2 2 0 0 0-1.19-.26A2.039 2.039 0 0 0 5 7.09V13a2.006 2.006 0 0 0 2 2h5v5h2v-5.5a2.006 2.006 0 0 0-2-2H9V9.05A8.531 8.531 0 0 0 14 11zm-6.17 5A3 3 0 0 1 5 18a3 3 0 0 1-3-3 3.013 3.013 0 0 1 2-2.83V10.1A5 5 0 0 0 0 15a5 5 0 0 0 5 5 5 5 0 0 0 4.9-4zM7 4a2 2 0 0 0 2-2 2 2 0 0 0-2-2 2 2 0 0 0-2 2 2 2 0 0 0 2 2z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
